import React, { Component } from 'react';
import MobileHeader from './../components/MobileHeader/MobileHeader';
import { Router, IndexRoute, Route } from 'react-router';
import Immutable from 'immutable';
import {firebaseRoot} from './../utils/firebase-utils';
import ReactFireMixin from 'reactfire';
import 'react-tap-event-plugin';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import TouchLink from '../components/TouchLink';

import Navbar from 'react-bootstrap/lib/Navbar';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';

require('../../public/static/css/styles.scss');

const App = React.createClass({
    mixins: [
        ReactFireMixin
    ],

    contextTypes: {
        history: React.PropTypes.object.isRequired
    },

    getInitialState() {
        return {
            admins: null,
            superadmins: null
        };
    },

    loaded() {
        if (!this['_onLoadedCalled'] && this.props.onLoaded) {
            this._onLoadedCalled = true;
            this.props.onLoaded();
        }
    },

    componentDidMount() {
        if (!firebaseRoot.getAuth()) {
            this.context.history.replaceState({nextPathname: this.context.location.pathname}, '/login');
        } else{
            this.bindAsArray(firebaseRoot.child('roles/admins'), "admins");
        }
    },

    firebaseDidCancel(error) {
        console.log(error);
        window.location.href = "/";
    },

    render() {
        if (!this.areAllBindingsLoaded()) {
            return <div>Loading...</div>;
        }

        return (
            <div className="admin-page">
                <div className="admin-page-nav">

                    <Navbar inverse>
                        <Navbar.Header>
                            <Navbar.Brand>
                                <TouchLink tabIndex={-1} to="/admin">Albert Admin</TouchLink>
                            </Navbar.Brand>
                            <Navbar.Toggle/>
                        </Navbar.Header>
                        <Navbar.Collapse>
                            <Nav>
                                <li tabIndex={-1}>
                                    <TouchLink to="/admin/import">Import</TouchLink>
                                </li>
                                <li tabIndex={-1}>
                                    <TouchLink to="/admin/roles">Roles</TouchLink>
                                </li>
                                <li tabIndex={-1}>
                                    <TouchLink to="/admin/video">Lessons</TouchLink>
                                </li>
                            </Nav>
                        </Navbar.Collapse>
                    </Navbar>
                </div>
                <div className="admin-page-content">

                    {this.props.children}
                </div>
            </div>
        );
    }
});

export default App;



/** WEBPACK FOOTER **
 ** ./src/admin/App.js
 **/